/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function (o) {
	var t = {
		url: !1,
		callback: !1,
		target: !1,
		duration: 120,
		on: 'mouseover',
		touch: !0,
		onZoomIn: !1,
		onZoomOut: !1,
		magnify: 1
	};
	(o.zoom = function (t, n, e, i) {
		var u,
			c,
			a,
			r,
			m,
			l,
			s,
			f = o(t),
			h = f.css('position'),
			d = o(n);
		return (
			(t.style.position = /(absolute|fixed)/.test(h) ? h : 'relative'),
			(t.style.overflow = 'hidden'),
			(e.style.width = e.style.height = ''),
			o(e)
				.addClass('zoomImg')
				.css({
					position: 'absolute',
					top: 0,
					left: 0,
					opacity: 0,
					width: e.width * i,
					height: e.height * i,
					border: 'none',
					maxWidth: 'none',
					maxHeight: 'none'
				})
				.appendTo(t),
			{
				init: function () {
					(c = f.outerWidth()),
						(u = f.outerHeight()),
						n === t ? ((r = c), (a = u)) : ((r = d.outerWidth()), (a = d.outerHeight())),
						(m = (e.width - c) / r),
						(l = (e.height - u) / a),
						(s = d.offset());
				},
				move: function (o) {
					var t = o.pageX - s.left,
						n = o.pageY - s.top;
					(n = Math.max(Math.min(n, a), 0)), (t = Math.max(Math.min(t, r), 0)), (e.style.left = t * -m + 'px'), (e.style.top = n * -l + 'px');
				}
			}
		);
	}),
		(o.fn.zoom = function (n) {
			return this.each(function () {
				var e = o.extend({}, t, n || {}),
					i = (e.target && o(e.target)[0]) || this,
					u = this,
					c = o(u),
					a = document.createElement('img'),
					r = o(a),
					m = 'mousemove.zoom',
					l = !1,
					s = !1;
				if (!e.url) {
					var f = u.querySelector('img');
					if ((f && (e.url = f.getAttribute('data-src') || f.currentSrc || f.src), !e.url)) return;
				}
				c.one(
					'zoom.destroy',
					function (o, t) {
						c.off('.zoom'), (i.style.position = o), (i.style.overflow = t), (a.onload = null), r.remove();
					}.bind(this, i.style.position, i.style.overflow)
				),
					(a.onload = function () {
						function t(t) {
							f.init(), f.move(t), r.stop().fadeTo(o.support.opacity ? e.duration : 0, 1, o.isFunction(e.onZoomIn) ? e.onZoomIn.call(a) : !1);
						}
						function n() {
							r.stop().fadeTo(e.duration, 0, o.isFunction(e.onZoomOut) ? e.onZoomOut.call(a) : !1);
						}
						var f = o.zoom(i, u, a, e.magnify);
						'grab' === e.on
							? c.on('mousedown.zoom', function (e) {
									1 === e.which &&
										(o(document).one('mouseup.zoom', function () {
											n(), o(document).off(m, f.move);
										}),
										t(e),
										o(document).on(m, f.move),
										e.preventDefault());
							  })
							: 'click' === e.on
							? c.on('click.zoom', function (e) {
									return l
										? void 0
										: ((l = !0),
										  t(e),
										  o(document).on(m, f.move),
										  o(document).one('click.zoom', function () {
												n(), (l = !1), o(document).off(m, f.move);
										  }),
										  !1);
							  })
							: 'toggle' === e.on
							? c.on('click.zoom', function (o) {
									l ? n() : t(o), (l = !l);
							  })
							: 'mouseover' === e.on && (f.init(), c.on('mouseenter.zoom', t).on('mouseleave.zoom', n).on(m, f.move)),
							e.touch &&
								c
									.on('touchstart.zoom', function (o) {
										o.preventDefault(),
											s ? ((s = !1), n()) : ((s = !0), t(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]));
									})
									.on('touchmove.zoom', function (o) {
										o.preventDefault(), f.move(o.originalEvent.touches[0] || o.originalEvent.changedTouches[0]);
									})
									.on('touchend.zoom', function (o) {
										o.preventDefault(), s && ((s = !1), n());
									}),
							o.isFunction(e.callback) && e.callback.call(a);
					}),
					a.setAttribute('role', 'presentation'),
					(a.alt = ''),
					(a.src = e.url);
			});
		}),
		(o.fn.zoom.defaults = t);
})(window.jQuery);

$(document).ready(function () {
	// ============== INIT =============//
	let myProductArray = myProductGroup.myProductArray;
	let myProductMasterArray = myProductGroup.myProductMasterArray;
	let myColorArray = myProductGroup.myColorArray;
	let mySizeArray = myProductGroup.mySizeArray;
	let myProductPackItemArray = myProductGroup.myProductPackItemArray;
	let myColorSelectionImageIndex = 0;
	//========= AWAKE FROM NIB =========//
	// Zoom Image  - http://www.jacklmoore.com/zoom
	const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	if (!isMobileDevice) {
		// zoom disabled for mobile - tapping enlarges
		$('#zoomImage').zoom({
			url: '/tuplo/images_app/large/' + myIDProductMaster + '.jpg',
			icon: false
		});
	}

	$('#mainImage').on('error', function () {
		$(this).attr('src', '/tuplo/images_app/medium/0000.jpg');
	});

	$('#zoomImage').on('click', function () {
		const theIDProductMaster = myIDProductMasterForColor(myColorSelection); // if there are colors - get current selection
		const theProductMaster = myProductMasterForID(theIDProductMaster);
		const theFilename = theProductMaster.myImageArray[myColorSelectionImageIndex].myFilename;
		showOverlayFile('/product-image?idpm=' + theFilename);
	});

	// // Color
	const theColorElement = document.getElementById('colors');
	//Check if the dom element exists before binding events
	if (theColorElement) {
		if (theColorElement.tagName === 'DIV') {
			// selection badges
			$.each(myColorArray, function (theIndex, theColor) {
				$('#color' + theColor.myID).bind('mouseenter', function () {
					$('#colorTitleDisplayed').html(theColor.myTitle);
					toggleImageForColor(theColor);
					toggleSizeStateForColor(theColor);
				});

				$('#color' + theColor.myID).bind('mouseleave', function () {
					let theColorTitle = myColorSelection ? myColorSelection.myTitle : 'Choose';
					$('#colorTitleDisplayed').html(theColorTitle);
					toggleSizeStateForColor(myColorSelection);
					toggleImageForColor(myColorSelection);
				});

				$('#color' + theColor.myID).click(function (theEvent) {
					theEvent.preventDefault();
					colorSelectionChanged(theColor);
				});
			});
		} else {
			// dropdown
			theColorElement.addEventListener('change', function () {
				const theIDColor = this.options[this.selectedIndex].value;
				const theColor = myColorArray.find((obj) => obj.myID === theIDColor);
				colorSelectionChanged(theColor);
			});
		}
	}

	function colorSelectionChanged(theColor) {
		if (theColor != myColorSelection) {
			const theIDProductMaster = myIDProductMasterForColor(theColor);
			const theProductMaster = myProductMasterForID(theIDProductMaster);
			if (myColorSelectionImageIndex + 1 > theProductMaster.myImageArray.length) {
				myColorSelectionImageIndex = 0;
			}

			$('#colorTitleDisplayed').html(theColor.myTitle);
			toggleSizeStateForColor(theColor);
			toggleImageForColor(theColor);
			toggleImageAltGalleryForColor(theColor);
			myColorSelection = theColor;
			myPackSelection = false; // reset
			selectionChanged();
		}
	}

	// Size
	const theSizeElement = document.getElementById('sizes');
	//Check if the dom element exists before binding events
	if (theSizeElement) {
		if (theSizeElement.tagName === 'DIV') {
			// selection badges
			console.log('sizes div:', $('div#sizes'));
			$.each(mySizeArray, function (theIndex, theSize) {
				if (mySizeArray.length > 1) {
					$('#size' + theSize.myID).bind('mouseenter', function () {
						$('#sizeTitleDisplayed').html(theSize.myTitle);
					});

					$('#size' + theSize.myID).bind('mouseleave', function () {
						let theSizeTitle = mySizeSelection ? mySizeSelection.myTitle : 'Choose';
						$('#sizeTitleDisplayed').html(theSizeTitle);
					});
				}

				$('#size' + theSize.myID).click(function (theEvent) {
					theEvent.preventDefault();
					sizeSelectionChanged(theSize);
				});
			});
		} else {
			// dropdown
			document.getElementById('sizes').addEventListener('change', function () {
				const theIDSize = this.options[this.selectedIndex].value;
				const theSize = mySizeArray.find((obj) => obj.myID === theIDSize);
				sizeSelectionChanged(theSize);
			});
		}
	}

	function sizeSelectionChanged(theSize) {
		if (theSize != mySizeSelection) {
			mySizeSelection = theSize;
			myPackSelection = false; // reset
			selectionChanged();
		}
	}

	// Image Alt
	$(document).on('click', '.tk-productImageAltItem', function (e) {
		e.preventDefault();
		myColorSelectionImageIndex = parseInt(this.dataset.index);
		toggleImageForColor(myColorSelection);
		$('.tk-productImageAltItem').removeClass('tk-selected');
		$('#tk-productImageAltGallery .tk-productImageAltItem:nth-child(' + (myColorSelectionImageIndex + 1) + ')').addClass('tk-selected');
	});

	// Packs
	if (myProductPackItemArray.length > 0) {
		$('#packs').on('click', '.packItem', function (theEvent) {
			theEvent.preventDefault();
			let theIDPackItem = theEvent.target.id.replace('packItem', '');
			myPackSelection = false; // reset – if an non-individual pack was selected prev and we now select individual pack it does not get found below and the prev selection remains

			$.each(myProductPackItemArray, function (theIndex, thePackItem) {
				if (thePackItem.myID == theIDPackItem) {
					myPackSelection = thePackItem;
				}
			});

			//Removes selected from any pack that is not the item
			$('.packItem').removeClass('selected');
			$('#packItem' + theIDPackItem).addClass('selected');

			selectionChanged(false); // pass false b/c we don't need to redraw pack menu and thus miss CSS animations
		});
	}

	// cart adjustments
	$('#quantityAdjustPlus').click(function (theEvent) {
		theEvent.preventDefault();
		adjustCartQuantity('plus');
		toggleAddToCartBox();
	});

	$('#quantityAdjustMinus').click(function (theEvent) {
		theEvent.preventDefault();
		adjustCartQuantity('minus');
		toggleAddToCartBox();
	});

	$('#cartQuantity').change(function (theEvent) {
		theEvent.preventDefault();
		adjustCartQuantity('user');
		toggleAddToCartBox();
	});

	$('#cartForm').submit(function (theEvent) {
		theEvent.preventDefault();
		if (myPackSelection && myPackSelection.myIDProduct > 0) {
			// myIDProduct == 0 means they choose an individual item - not pack
			// if (Number(myProduct.myInventory) < (Number(myPackSelection.myQuantity) * Number($('#cartQuantity').val())))
			// 	{
			// 	let theQuantityAvailable = Math.floor(Number(myProduct.myInventory) / Number(myPackSelection.myQuantity));
			// 	alert('We\'re sorry, but we have insufficient quantity for this item. You indicated you wanted '+$('#cartQuantity').val()+', but we have '+theQuantityAvailable+' available. Please adjust your quantity to continue.')
			// 	return;
			// 	}

			showCart(true, '?cartAction=addProduct&qty=' + $('#cartQuantity').val() + '&pid=' + myPackSelection.myIDProduct + '-' + myPackSelection.myID);
		} else if (myProduct) {
			// if (Number(myProduct.myInventory) < Number($('#cartQuantity').val()))
			// 	{
			// 	alert('We\'re sorry, but we have insufficient quantity for this item. You indicated you wanted '+$('#cartQuantity').val()+', but we have '+myProduct.myInventory+' available. Please adjust your quantity to continue.')
			// 	return;
			// 	}

			showCart(true, '?cartAction=addProduct&qty=' + $('#cartQuantity').val() + '&pid=' + myProduct.myID + '-0');
		} // all that's left are incomplete selections - should not happen if JS is working bc button should be disabled
		else {
			return;
		}
	});

	// =========== SELECTIONS ==========//
	// MASTER
	function selectionChanged(shouldTogglePackState = true) {
		myProduct = false;

		$.each(myProductArray, function (theIndex, theProduct) {
			if (
				(theProduct.myIDColor == myColorSelection.myID || myColorArray.length == 0) &&
				(theProduct.myIDSize == mySizeSelection.myID || mySizeArray.length == 0)
			) {
				myProduct = theProduct;
				return;
			}
		});

		toggleSizeStateForColor(myColorSelection);
		toggleColorState();
		if (shouldTogglePackState) {
			togglePackState();
		}
		togglePrice();
		toggleAddToCartButton();

		// Availability
		if (myPackSelection) {
			$('#availabilityDisplayed').html(
				Number(myProduct.myInventoryAvailable) >= Number(myPackSelection.myQuantity) && Number(myProduct.isPurchasable) == 1
					? '<span class="inStock">In Stock</span>'
					: '<span class="outOfStock">Out of Stock</span>'
			);
		} else if (myProductGroup.shouldSellPacksOnly == '0' && myProduct) {
			$('#availabilityDisplayed').html(
				Number(myProduct.myInventoryAvailable) > 0 && Number(myProduct.isPurchasable) == 1
					? '<span class="inStock">In Stock</span>'
					: '<span class="outOfStock">Out of Stock</span>'
			);
		} else if (myColorSelection && mySizeSelection) {
			$('#availabilityDisplayed').html('<span class="nilStock">Unavailable</span>');
		} else {
			$('#availabilityDisplayed').html('<span class="nilStock">Make a Selection</span>');
		}

		// ID and SKU
		let thePackCode = myPackSelection && Number(myPackSelection.myID > 0) ? '-' + myPackSelection.myCode : '';
		$('#itemNumberDisplayed').html(myProduct ? myProduct.myID + thePackCode : 'N/A');
		$('#skuDisplayed').html(myProduct && myProduct.mySKU != '' ? myProduct.mySKU : 'N/A');

		// Count
		let theCount = myProduct && Number(myProduct.myCount) > 1 ? Number(myProduct.myCount) : 0;
		theCount = myPackSelection && Number(myProduct.myCount) > 1 ? Number(myProduct.myCount) * Number(myPackSelection.myQuantity) : theCount;
		// let theCountSavings = (myProduct.myPrice / theCount);
		// theCountSavings = (theCountSavings >= 1) ? '$'+theCountSavings.toFixed(2) : (theCountSavings * 100).toFixed(1)+'¢';
		// let theCountDetail = (theCount > 1) ? ' ('+theCountSavings+' per item)' : '';
		let theCountTitle = theCount > 1 ? 'Count:' : '';
		theCount = theCount > 1 ? theCount + ' ' + myProductGroup.myItemNamePlural.toLowerCase() : '';
		$('#countTitle').html(theCountTitle);
		$('#countDisplayed').html(theCount);
	}

	function toggleImageAltGalleryForColor(theColor) {
		let theIDProductMaster = myIDProductMasterForColor(theColor);
		let theProductMaster = myProductMasterForID(theIDProductMaster);

		if (theProductMaster && theProductMaster.myImageArray.length > 1) {
			let theImageAltGallery = '';

			$.each(theProductMaster.myImageArray, function (theIndex, theImageObject) {
				let theAltText = escapeHtml(myProductGroup.myBrand + ' ' + myProductGroup.myTitle + ' ' + theColor.myTitle + ' " <> image ' + (theIndex + 1)); // escape for HTML
				let theCSS = theIndex == myColorSelectionImageIndex ? ' tk-selected' : '';
				theImageAltGallery +=
					'<div class="tk-productImageAltItem' +
					theCSS +
					'" data-index="' +
					theIndex +
					'"><img src="/tuplo/images_app/x-small/' +
					theImageObject.myFilename +
					'.' +
					theImageObject.myCodec +
					'" height=48 width=48 alt="' +
					theAltText +
					'"></div>';
			});

			$('#tk-productImageAltGallery').html(theImageAltGallery);
		} else {
			$('#tk-productImageAltGallery').html(''); // empty the div if only 1 or 0
		}
	}

	function toggleImageForColor(theColor) {
		const theIDProductMaster = myIDProductMasterForColor(theColor);
		const theProductMaster = myProductMasterForID(theIDProductMaster);
		const theIndex = theProductMaster.myImageArray.length < myColorSelectionImageIndex + 1 ? 0 : myColorSelectionImageIndex;
		const theFilename = theProductMaster.myImageArray[theIndex].myFilename + '.' + theProductMaster.myImageArray[theIndex].myCodec;

		$('#mainImage').attr('src', '/tuplo/images_app/medium/' + theFilename);

		if (!isMobileDevice) {
			$('#zoomImage').trigger('zoom.destroy'); // remove zoom
			$('#zoomImage').zoom({
				url: '/tuplo/images_app/large/' + theFilename,
				icon: false
			});
		}
	}

	function myIDProductMasterForColor(theColor) {
		let theIDProductMaster = false;

		$.each(myProductArray, function (theIndex, theProduct) {
			if (theProduct.myIDColor == theColor.myID) {
				theIDProductMaster = theProduct.myIDProductMaster;
				return false; // this is = break; as each() is jquery function
			}
		});

		if (!theIDProductMaster) {
			// if there were no colors then choose the default image
			theIDProductMaster = myIDProductMaster;
		}

		return theIDProductMaster;
	}

	function myProductMasterForID(theID) {
		let theProductMaster = false;

		$.each(myProductMasterArray, function (theIndex, theObject) {
			if (theObject.myID == theID) {
				theProductMaster = theObject;
				return false; // this is = break; as each() is jquery function
			}
		});

		return theProductMaster;
	}

	// toggle price
	function togglePrice() {
		let thePrice = 'N/A';
		let thePriceDetail = '';
		const theFormatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD'
		});

		if (myPackSelection && myProduct) {
			thePrice = Number(myPackSelection.myID) > 0 ? theFormatter.format(myPackSelection.myPrice) : theFormatter.format(myProduct.myPrice);

			if (myPackSelection.myQuantity > 1) {
				let thePricePerUnit = (Number(myPackSelection.myPrice) / Number(myPackSelection.myQuantity)).toFixed(2);
				let theSavings = Number(myProduct.myPrice) - thePricePerUnit;
				let thePercent = Math.ceil((theSavings / Number(myProduct.myPrice)) * 100);
				thePriceDetail = theFormatter.format(thePricePerUnit) + ' each'; // always show price per item ven if no savings
				thePriceDetail += thePercent >= 1 ? ' (Save ' + thePercent + '%)' : '';
			}
		} else if (myProduct && !myPackSelection) {
			// make sure there are no ppi selected so this doesn't catch size/color combos that do not exist
			if (Number(myProduct.myPrice) > 0) {
				thePrice = theFormatter.format(myProduct.myPrice);

				if (Number(myProduct.myPriceMSRP) - Number(myProduct.myPrice) >= 1) {
					let theSavings = (Number(myProduct.myPriceMSRP) - Number(myProduct.myPrice)).toFixed(2);
					let thePercent = Math.ceil((theSavings / Number(myProduct.myPriceMSRP)) * 100);
					thePriceDetail =
						'<span style="text-decoration: line-through;">' +
						theFormatter.format(myProduct.myPriceMSRP) +
						'</span> - Save ' +
						theFormatter.format(theSavings) +
						' (' +
						thePercent +
						'%)';
				}
			}
		} else if (hasPriceRange && !myColorSelection && !mySizeSelection) {
			// this really shouldn't happen right? the page starts with selection so it's a non-starter as user cannot unselect color/size
			thePrice = theFormatter.format(myPriceLow) + ' <span class="fontLight">to</span> ' + theFormatter.format(myPriceHigh);

			// find the biggest discrepency
			let theSavings = 0.0;

			$.each(myProductArray, function (theIndex, theProduct) {
				if (Number(theProduct.myPriceMSRP) - Number(theProduct.myPrice) > theSavings) {
					theSavings = Number(theProduct.myPriceMSRP) - Number(theProduct.myPrice);
				}
			});

			if (theSavings >= 1) {
				thePriceDetail = 'Save up to ' + theFormatter.format(theSavings);
			}
		}
		// else if (myPriceHigh > 0)
		// 	{
		// 	thePrice = theFormatter.format(myPriceHigh);

		// 	if ((Number(myPriceMSRP) - Number(myPriceHigh)) >= 1)
		// 		{
		// 		thePriceDetail += theFormatter.format(myProductArray[0].myPriceMSRP)+' - Save '+theFormatter.format((Number(myProductArray[0].myPriceMSRP) - Number(myPriceHigh)));
		// 		}
		// 	}

		$('#priceDisplayed').html(thePrice);
		$('#priceDetailBox').html(thePriceDetail);
	}

	function toggleAddToCartBox() {
		const theLimitMax = Number(myProductGroup.myOrderLimit);
		let theQuantityCurrent = Number($('#cartQuantity').val());

		// Enforce max limit
		if (theLimitMax > 0) {
			if (theQuantityCurrent > theLimitMax) {
				theQuantityCurrent = theLimitMax;
				$('#cartQuantity').val(theLimitMax);
			}

			// Disable plus button if at limit
			$('#quantityAdjustPlus').prop('disabled', theQuantityCurrent >= theLimitMax);
		} else {
			// If unlimited, always enable plus
			$('#quantityAdjustPlus').prop('disabled', false);
		}

		// Always update cart button state after quantity adjustments
		toggleAddToCartButton();
	}
	// toggle cart button
	function toggleAddToCartButton() {
		let theCartQuantity = Number($('#cartQuantity').val());

		// Disable if order limit is reached or exceeded
		if (Number(myProductGroup.myOrderLimit) > 0 && theCartQuantity > Number(myProductGroup.myOrderLimit)) {
			$('#addToCartButton').attr('disabled', true);
			return;
		}

		if (myPackSelection) {
			$('#addToCartButton').attr(
				'disabled',
				Number(myProduct.myInventoryAvailable) >= Number(myPackSelection.myQuantity) && Number(myProduct.isPurchasable) == 1 ? false : true
			);
		} else if (
			myProductGroup.shouldSellPacksOnly == '0' &&
			myProduct &&
			Number(myProduct.myInventoryAvailable) > 0 &&
			Number(myProduct.isPurchasable) == 1
		) {
			$('#addToCartButton').attr('disabled', false);
		} else {
			$('#addToCartButton').attr('disabled', true);
		}
	}

	// toggle sizes
	function toggleSizeStateForColor(theColor) {
		// turn off sizes with zero inventory
		$.each(mySizeArray, function (theIndex, theSize) {
			let sizeHasInventoryForColor = false;

			$.each(myProductArray, function (theIndex, theProduct) {
				if ((theProduct.myIDColor == theColor.myID || myColorArray.length == 0) && theProduct.myIDSize == theSize.myID) {
					sizeHasInventoryForColor = Number(theProduct.myInventoryAvailable) > 0 && Number(theProduct.isPurchasable) == 1 ? true : false;
				}
			});

			if ($('div#sizes').length) {
				// selection badges
				$('#size' + theSize.myID).removeClass('selected');
				$('#size' + theSize.myID).removeClass('off');

				if (!mySizeSelection && !sizeHasInventoryForColor) {
					$('#size' + theSize.myID).addClass('off');
				} else if (!sizeHasInventoryForColor && mySizeSelection && mySizeSelection.myID == theSize.myID) {
					$('#size' + theSize.myID).addClass('selected off');
				} else if (!sizeHasInventoryForColor) {
					// Off
					$('#size' + theSize.myID).addClass('off');
				} else if (mySizeSelection && mySizeSelection.myID == theSize.myID) {
					// selected - has inventory and is selected
					$('#size' + theSize.myID).addClass('selected');
				}
			} else {
				// dropdown
				// future styling here
				// if (sizeHasInventoryForColor) {
				// 	$('#size' + theSize.myID).text(theSize.myTitle);
				// } else {
				// 	$('#size' + theSize.myID).text(theSize.myTitle);
				// }
			}
		});
	}

	// toggle colors
	function toggleColorState() {
		$.each(myColorArray, function (theIndex, theColor) {
			if (theColor.myID == myColorSelection.myID) {
				$('#color' + theColor.myID).addClass('selected');
			} else {
				$('#color' + theColor.myID).removeClass('selected');
			}
		});
	}

	// toggle packs
	function togglePackState() {
		if (myProduct) {
			let thePackContent = '';
			let isFirstLoop = true;
			let theProductPackItemArray = [];
			let didFindPack = false;

			// filter
			$.each(myProductPackItemArray, function (theIndex, thePackItem) {
				if (isFirstLoop && myProductGroup.shouldSellPacksOnly == '0') {
					let thePackItem2 = {
						myID: '0',
						myQuantity: '1',
						myTitle: 'Individual',
						myCode: ''
					};
					theProductPackItemArray.push(thePackItem2);
				}

				if (myProduct && thePackItem.myIDProduct == myProduct.myID) {
					theProductPackItemArray.push(thePackItem);

					if (thePackItem.myID == myPackSelection.myID) {
						didFindPack = true;
					}
				}

				isFirstLoop = false;
			});

			// draw
			isFirstLoop = true;

			$.each(theProductPackItemArray, function (theIndex, thePackItem) {
				let theFilePath =
					'/shop/p' + thePackItem.myIDProductMaster + '/' + myProductGroup.myTitlePath + '?cs=' + thePackItem.myIDColor + '-' + thePackItem.myIDSize;
				let theClassText = myPackSelection.myID == thePackItem.myID ? ' selected' : '';

				if (isFirstLoop && !didFindPack) {
					theClassText = ' selected';
					myPackSelection = thePackItem; // reset pack selection since likely size or color changed and the pack ID is no longer available
				}

				thePackContent +=
					'<a href="' +
					theFilePath +
					'-' +
					thePackItem.myID +
					'" id="packItem' +
					thePackItem.myID +
					'" class="packItem' +
					theClassText +
					'">' +
					thePackItem.myTitle +
					'</a>';
				isFirstLoop = false;
			});

			let isSoloItem =
				theProductPackItemArray.length == 1 && Number(theProductPackItemArray[0].myQuantity) == 1 && theProductPackItemArray[0].myCode == '';
			let theTitle = thePackContent == '' ? '' : '<div class="attributeTitle">Options</div>';
			thePackContent = isSoloItem || thePackContent == '' ? '' : theTitle + thePackContent;
			$('#packs').html(thePackContent);
		} else {
			$('#packs').html('');
		}
	}

	// cart qty adjust
	function adjustCartQuantity(theAdjustmentType) {
		let theCartQuantity = Number($('#cartQuantity').val());

		theCartQuantity = isNaN(theCartQuantity) || theCartQuantity < 1 ? 1 : theCartQuantity;

		if (theAdjustmentType == 'user') {
			$('#cartQuantity').val(theCartQuantity);
		} else {
			let theCartQuantityMinus = theCartQuantity == 1 ? 1 : theCartQuantity - 1;
			let theCartQuantityPlus = theCartQuantity + 1;
			let theCartQuantityNew = theAdjustmentType == 'plus' ? theCartQuantityPlus : theCartQuantityMinus;
			$('#cartQuantity').val(theCartQuantityNew);
		}
	}
});
